import React, { useEffect, useState } from 'react';
import SeachInput from 'components/form/SeachInput';
import Card from 'components/Layout/Card';
import Loader from 'components/Layout/Loader';
import { Col, Pagination, Row } from 'react-bootstrap';
import { eventLogoPath, icons } from 'utils/constants';
import FollowUpAndDiscountCard from './FollowUpAndDiscountCard';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUpcomingConference } from 'store/slices';
import { generatePreSignedUrl, objectToFormData } from 'utils/helpers';
import ReactPaginate from 'react-paginate';
import Dropdown from 'components/form/Dropdown';
import CalendarFilterDropdown from 'components/Layout/CalendarFilterDropdown';

const FollowUpAndDiscount = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [tableList, setTableList] = useState([]);
  const [formattedEvents, setFormattedEvents] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [newPaginateActivePage, setNewPaginateActivePage] = useState(0);

  const [searchPayload, setSearchPayload] = useState({
    event_name: '',
    country: '',
    start_date: '',
    end_date: '',
  });
  const [filterData, setFilterData] = useState({
    total: 0,
    offset: 0,
    limit: 9,
  });
  const [timer, setTimer] = useState(null);

  const dispatch = useDispatch();
  const handleSearch = (e) => {
    let value = e.target.value;
    setSearchText(value);

    clearTimeout(timer);
    const newTimer = setTimeout(() => {
      const updatedSearchPayload = { event_name: value };
      setSearchPayload(updatedSearchPayload);
      const updatedFilterData = {
        ...filterData,
        offset: 0,
        ...updatedSearchPayload,
      };
      setFilterData(updatedFilterData);
      setIsLoading(true);
      fetchUpcomingConferenceData(updatedFilterData);
    }, 800);
    setTimer(newTimer);
  };

  const fetchUpcomingConferenceData = async (obj) => {
    let formData = objectToFormData(obj);
    const response = await dispatch(fetchUpcomingConference(formData));
    if (response.status === 200) {
      setTableList(response?.data?.events);
      setFilterData((prev) => ({
        ...prev,
        total: response?.data?.result_count || 0,
      }));
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchUpcomingConferenceData({ ...filterData, ...searchPayload });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const formatEventDate = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);

    const dayOptions = { day: 'numeric' };
    const monthOptions = { month: 'short' };
    const yearOptions = { year: 'numeric' };

    const startDay = new Intl.DateTimeFormat('en-US', dayOptions).format(start);
    const endDay = new Intl.DateTimeFormat('en-US', dayOptions).format(end);
    const month = new Intl.DateTimeFormat('en-US', monthOptions).format(end);
    const year = new Intl.DateTimeFormat('en-US', yearOptions).format(end);

    if (start.toDateString() === end.toDateString()) {
      return `${startDay}-${month}-${year}`;
    }

    return `${startDay} & ${endDay}-${month}-${year}`;
  };

  useEffect(() => {
    const fetchEventLogos = async () => {
      if (tableList.length === 0) {
        setFormattedEvents([]);
        return;
      }

      const eventsWithUrls = await Promise.all(
        tableList.map(async (event) => {
          const logoUrl = event?.event_logo
            ? await generatePreSignedUrl(event.event_logo, eventLogoPath)
            : icons.logo;

          return {
            logo: logoUrl,
            title: event.event_name,
            date: formatEventDate(event.start_date, event.end_date),
            location: `${event.city_name}, ${event.country_name}`,
            event_id: event.event_id,
          };
        })
      );

      setFormattedEvents(eventsWithUrls);
    };

    fetchEventLogos();
  }, [tableList]);

  const handlePageChange = (selectedPage) => {
    const newOffset = selectedPage.selected * filterData.limit;
    const updatedFilterData = { ...filterData, offset: newOffset };
    setNewPaginateActivePage(selectedPage.selected);
    fetchUpcomingConferenceData(updatedFilterData);
  };

  const totalPage = Math.ceil(filterData.total / filterData.limit);

  const { countryList } = useSelector((state) => ({
    countryList: state.global.countryList,
  }));

  const handelChangeInput = (e) => {
    let newPayload = '';
    if (e.target.value === 'custom') {
      newPayload = {
        ...searchPayload,
        start_date: e.target.start_date,
        end_date: e.target.end_date,
      };
      fetchUpcomingConferenceData(newPayload);
      setSearchPayload(newPayload);
    } else {
      if (searchPayload?.start_date && searchPayload?.end_date) {
        const { start_date, end_date, ...newSearchObject } = searchPayload;
        setSearchPayload({ ...newSearchObject });
      } else {
        setSearchPayload({ ...searchPayload });
      }
    }
  };

  return (
    <div className="segment-management-container">
      <Card className="cpt-20 cpe-20 cps-20 cpb-34">
        <div className="d-flex align-items-center justify-content-between cmb-5">
          <div className="table-title">
            Upcoming Conference ({filterData?.total})
          </div>

          <div className="d-flex align-items-center flex-wrap gap-3">
            <div style={{ width: '200px' }}>
              <SeachInput
                placeholder="Search"
                value={searchText}
                onChange={handleSearch}
              />
            </div>
            <div style={{ width: '150px' }}>
              <Dropdown
                id="country"
                placeholder="Country"
                options={countryList}
                optionKey="id"
                optionValue="country"
                onChange={(e) => {
                  const selectedCountry = e.target.value;
                  const updatedSearchPayload = {
                    ...searchPayload,
                    country: selectedCountry,
                  };
                  setSearchPayload(updatedSearchPayload);

                  const updatedFilterData = {
                    ...filterData,
                    offset: 0,
                    ...updatedSearchPayload,
                  };
                  setFilterData(updatedFilterData);
                  setIsLoading(true);
                  fetchUpcomingConferenceData(updatedFilterData);
                }}
              />
            </div>
            
              <CalendarFilterDropdown
                onChange={handelChangeInput}
                elem={{ title: 'Join Date' }}
                custom_type={true}
              />
            
          </div>
        </div>
        <hr className="cmb-25" />
        {isLoading ? (
          <div className="center-flex cpt-50 cpb-50">
            <Loader size="md" />
          </div>
        ) : tableList?.length === 0 ? (
          <div className="d-flex align-items-center justify-content-center cpt-200 cpb-200">
            No data found
          </div>
        ) : (
          <>
            <div className="d-flex justify-content-center">
              <Row className="g-3 w-100">
                {formattedEvents?.map((conference, index) => (
                  <Col key={index} xs={12} sm={8} md={6} lg={4} xl={4}>
                    <FollowUpAndDiscountCard {...conference} />
                  </Col>
                ))}
              </Row>
            </div>

            {totalPage > 1 && (
              <div className="d-flex justify-content-center react-pagination cmt-50">
                <ReactPaginate
                  pageCount={totalPage}
                  breakLabel="..."
                  previousLabel="Prev"
                  nextLabel="Next"
                  renderOnZeroPageCount={null}
                  containerClassName="pagination"
                  previousLinkClassName="page-link"
                  nextLinkClassName="page-link"
                  activeClassName="active"
                  disabledLinkClassName="disable-page-link"
                  onPageChange={handlePageChange}
                  pageRangeDisplayed={5}
                  marginPagesDisplayed={2}
                  forcePage={newPaginateActivePage}
                />
              </div>
            )}
          </>
        )}
      </Card>
    </div>
  );
};

export default FollowUpAndDiscount;
